import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js';
import { CognitoConfiguration } from '@cognitoforms/utils/clientside-configuration';
import { isPrerender } from '@cognitoforms/utils/utilities';
import Vue from 'vue';
import type { IApplicationInsights } from '@microsoft/applicationinsights-web';

let appInsights: ApplicationInsights = null;
let clickAnalytics: ClickAnalyticsPlugin = null;

if (!isPrerender() && process.env.NODE_ENV !== 'development' && process.env.NODE_ENV !== 'test') {
	try {
		clickAnalytics = new ClickAnalyticsPlugin();
		appInsights = new ApplicationInsights({
			config: {
				connectionString: CognitoConfiguration.AppInsightsConnectionString,
				extensions: [clickAnalytics],
				extensionConfig: {
					[clickAnalytics.identifier]: {
						autoCapture: true,
						dropInvalidEvents: true,
						dataTags: {
							customDataPrefix: 'data-cf-',
							useDefaultContentNameOrId: false
						}
					}
				}
			}
		});
		appInsights.loadAppInsights();
	}
	catch (e) {
		appInsights = null;
		clickAnalytics = null;
		console.warn('AI failed to initialize:', e);
	}
}

export const AppInsights: () => IApplicationInsights = () => appInsights;

export const ClickAnalytics: () => ClickAnalyticsPlugin = () => clickAnalytics;

export default Vue.extend({
	name: 'CAppInsights',
	data() {
		return {
			appInsights
		};
	},
	watch: {
		$route: {
			immediate: true,
			handler(route) {
				if (appInsights && !route.meta.customReadyEvent)
					appInsights.stopTrackPage(route.name ?? route.path);
			}
		}
	},
	render() {
		return this.$slots.default;
	}
});